import { useMemo } from "react";
import { ArrowRight } from "lucide-react";
import { metalFill } from "@/components/sales/SalesQuickFilter";
import "@/components/booking-home/bookingHome.css";

const st = (f) => String(f.status || "").toLowerCase();

export function FranchiseTiles({ franchises, counts }) {
  counts = counts || {};
  const d = useMemo(() => {
    const today = new Date(Date.now() + 330 * 60000).toISOString().slice(0, 10);
    const in90 = new Date(Date.now() + 330 * 60000 + 90 * 86400000).toISOString().slice(0, 10);
    const end = (f) => f.agreement_end_date || f.franchise_agreement_end_date || "";
    return {
      onboarding: franchises.filter((f) => st(f) === "onboarding").length,
      renewals: franchises.filter((f) => end(f) && end(f) >= today && end(f) <= in90).length,
      closed: franchises.filter((f) => ["closed", "terminated", "archived"].includes(st(f))).length,
    };
  }, [franchises]);
  const tiles = [["Total Franchises", franchises.length, "all records"], ["Active Centres", counts.active, "operating"], ["Pending", counts.pending, "awaiting action"],
    ["Onboarding", d.onboarding, "being set up"], ["Renewals in 90 days", d.renewals, "agreement end date"], ["Terminated / Closed", d.closed, "exited"]];
  const flow = [["Onboarding", d.onboarding], ["Active", counts.active], ["Exit / closed", d.closed]];
  return (
    <div className="space-y-3" data-testid="franchise-metal-tiles">
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
        {tiles.map(([l, v, h], i) => (
          <div key={l} className="bi-tile" style={{ "--bi-fill": metalFill(i), animationDelay: `${i * 40}ms` }} data-testid={`franchise-tile-${i}`}>
            <span className="bi-tile-label">{l}</span><span className="bi-tile-value">{v}</span><span className="text-xs opacity-85">{h}</span>
          </div>))}
      </div>
      <div className="bi-panel flex flex-wrap items-center gap-2" data-testid="franchise-flow">
        <span className="mr-2 font-serif text-lg font-bold text-[#750817]">Franchise lifecycle</span>
        {flow.map(([l, v], i) => (
          <span key={l} className="flex items-center gap-2">
            <span className={`rounded-2xl border-2 px-4 py-2 text-base font-semibold ${i === 1 ? "border-emerald-300 bg-emerald-50 text-emerald-900" : i === 0 ? "border-[#e2b85a] bg-[#fff3d6] text-[#5a3a22]" : "border-stone-300 bg-stone-100 text-stone-700"}`}>{l} · {v}</span>
            {i < flow.length - 1 && <ArrowRight className="h-5 w-5 text-[#a8781f]" />}
          </span>))}
      </div>
    </div>
  );
}
